import { Colors } from '../../consts/Colors';
import Obstacle from '../Obstacle';

export default class Poisson1 extends Obstacle {
    constructor(scene, x, y, params = { showHitbox: false }) {
        super(scene, x, y, params);

        this.scene = scene;
        this.type = 'poisson1';
        this.speed = 400;
        this.setPosition(x, y);
        scene.add.existing(this);
    }

    addBody(params) {
        this.texture = this.scene.add.sprite(0, 0, 'poisson1').setOrigin(0.5);
        this.texture.anims.play('poissonAnim1');
        this.add(this.texture);
    }
}
